// Providing architecture for component in theme object
const videoCarousel = {
  default: {},
  featuredVideo: {}
};

export type VideoCarouselVariantsType = 'default' | 'featuredVideo';

export const videoCarouselVariants = Object.keys(videoCarousel) as VideoCarouselVariantsType[];

export default videoCarousel;
